import DOMPurify from 'dompurify';

// Tags/attrs allowlist + explicit URL-scheme allowlist (http/https/mailto only).
// The custom regex markdown below MUST stay behind this sanitizer.
const purifyConfig = {
  ALLOWED_TAGS: ['strong', 'em', 'code', 'a', 'br', 'p'],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
  ALLOWED_URI_REGEXP: /^(?:https?|mailto):/i,
};

// Convert a single paragraph of trusted-author markdown to sanitized HTML.
export const sanitizeNoticeParagraphs = (text: string): string[] => {
  return text.split(/\n\n+/).map((paragraph) => {
    const processed = paragraph
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.+?)\*/g, '<em>$1</em>')
      .replace(/`(.+?)`/g, '<code class="bg-dark-bg px-1 rounded text-xs">$1</code>')
      .replace(
        /\[(.+?)\]\((.+?)\)/g,
        '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-bull-blue hover:underline">$1</a>'
      )
      .replace(/\n/g, '<br />');
    return DOMPurify.sanitize(processed, purifyConfig);
  });
};
